<template>
  <div v-if="loadingCheck">
    <div class="loading-container" :style="areaStyle">
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
      <h4>{{ loadingMessage }}</h4>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheLoading",
  data() {
    return {
      loading: null,
    };
  },
  computed: {
    ...mapState({
      loadingCheck: "loadingCheck",
      loadingMessage: "loadingMessage",
    }),
    areaStyle() {
      const app = this.$vuetify.application;
      return {
        top: `${app.bar + app.top}px`,
        right: `${app.right}px`,
        bottom: `${app.footer + app.insetFooter + app.bottom}px`,
        left: `${app.left}px`,
      };
    },
  },
};
</script>
